import React, { Fragment } from "react";
import { Row, Button, PageHeader, DatePicker } from "antd";
import moment from 'moment';
const dateFormat = 'DD/MM/YYYY';

function FilterPeriod({action, handleInput, period, setPeriod, data, setData}){

    return(
        <div style={{background: '#fff', marginTop: -20}}>
            <PageHeader
                style={{
                    border: '1px solid rgb(235, 237, 240)', marginTop: 15, marginBottom: 15
                }}
                title="Periodo"
                avatar={{ src: require('../../img/calendar.png') }}
                subTitle={
                    <Fragment>
                        <Row>
                            <DatePicker 
                                style={{ marginRight: 10, marginLeft: 10 }}
                                defaultValue={moment(period.begin, dateFormat)}
                                format={dateFormat}
                                placeholder="Inicio"
                                onChange={e => handleInput(e, "begin", period)}
                            />
                            -
                            <DatePicker 
                                style={{ marginLeft: 10 }}
                                defaultValue={moment(period.end, dateFormat)}
                                format={dateFormat}
                                placeholder="Fim"
                                onChange={e => handleInput(e, "end", period)}
                            />
                        </Row>
                    </Fragment>
                }
                extra={[
                    <Button key="1" type="primary" shape="round" onClick={() => action(period.status)} style={{marginTop: 5}}>
                        Pesquisar
                    </Button>,
                ]}
            />
        </div>
    )
}

export default FilterPeriod;


// WEBPACK FOOTER //
// ./src/components/common/FilterPeriod.jsx